import {
    FETCH_DOMAINS_OVERVIEW_REQUEST,
    FETCH_DOMAINS_OVERVIEW_SUCCESS,
    FETCH_DOMAINS_OVERVIEW_FAILURE,
} from '../actions/types/domains-overview-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAINS_OVERVIEW_REQUEST:
            newState = true;
            break;
        case FETCH_DOMAINS_OVERVIEW_SUCCESS:
        case FETCH_DOMAINS_OVERVIEW_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function data( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_DOMAINS_OVERVIEW_SUCCESS:
            newState = {
                ...state,
                ...action.overviewData
            };
            break;
        case FETCH_DOMAINS_OVERVIEW_REQUEST:
        case FETCH_DOMAINS_OVERVIEW_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    data,
    isLoading,
} );
